export default __webpack_public_path__ + "static/media/send-solid-blue.d6c4c2aa.svg";